import { render, staticRenderFns } from "./ZisPaymentConfirm.vue?vue&type=template&id=c6d13cd4"
import script from "./ZisPaymentConfirm.vue?vue&type=script&lang=js"
export * from "./ZisPaymentConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports